import React from 'react';
import PropTypes from 'prop-types';
import { publicAssetsPrefix } from '../../../../../../../configuration';

export default function Countries({ countries = [], query }) {
  return countries.map(({ country, countryCode, postalCodes, preselected }) => (
    <li
      key={countryCode}
      className={`country ${preselected ? 'country-open' : ''}`}
    >
      <div className="country-header">
        <span className="country-flag">
          <img
            className="img-responsive img-round"
            src={`${publicAssetsPrefix}/img/country-flag/${countryCode.toLowerCase()}.svg`}
            alt={country}
          />
        </span>
        <span className="country-name">{country}</span>
      </div>
      <ul
        className="country-codes"
        style={{ display: preselected ? 'block' : '' }}
      >
        {postalCodes.map(({ postalCode, location, placeId }) => (
          <li
            key={placeId}
            className="country-code"
            data-postal-code-id={postalCode}
            data-postal-code-country={countryCode}
            data-postal-code-place-id={placeId}
            data-postal-code-prefer-not-to-say=""
          >
            <span
              // eslint-disable-next-line react/no-danger
              dangerouslySetInnerHTML={{
                __html: postalCode.replace(
                  query,
                  `<span class="highlight">${query}</span>`,
                ),
              }}
            />
            , {location}
          </li>
        ))}
      </ul>
    </li>
  ));
}

Countries.propTypes = {
  countries: PropTypes.array,
  query: PropTypes.string,
};
